import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faUser, faLock, faHome, faBell, faSignOutAlt, faKey, faAddressCard, faBars, faTimes, faPlus,
  faEdit, faTrashAlt, faEnvelope, faSave, faEye, faBuilding, faClipboardList, faBook, faSitemap,
  faTable, faCalendarAlt, faSearch, faList, faUserTie, faUserGraduate, faAddressBook, faUserClock,
  faHourglassHalf, faCalendarDay, faCalendarPlus, faMinus, faClock, faUserPlus, faShare, faSpinner,
  faCheck, faUserCheck, faArrowCircleRight, faHourglass
} from "@fortawesome/free-solid-svg-icons";
import { faFacebook, faGithub, faLinkedin } from "@fortawesome/free-brands-svg-icons";

library.add(faUser, faLock, faHome, faBell, faSignOutAlt, faKey, faAddressCard, faBars,
  faTimes, faPlus, faEdit, faTrashAlt, faEnvelope, faSave, faEye, faLinkedin, faGithub,
  faFacebook, faBuilding, faClipboardList, faBook, faSitemap, faTable, faCalendarAlt,
  faSearch, faList, faUserTie, faUserGraduate, faAddressBook, faUserClock, faHourglassHalf,
  faCalendarDay, faCalendarPlus, faMinus, faClock, faUserPlus, faShare, faSpinner, faCheck,
  faUserCheck, faArrowCircleRight, faHourglass);
